export const isExternalUrl = (url: string) => {
  if (!url) return null
  const regex = /^(https?:\/\/|www\.)/
  return regex.test(url)
}
